<template>
  <div>
    <Sidebar></Sidebar>
    <Header></Header>
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="mt-4">
            <a href="#/post">< Voltar</a>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h3 class="my-4" v-show="this.$route.params.id === 'novo'">
            Novo {{ this.entity.por }}
          </h3>
          <h3 class="my-4" v-show="this.$route.params.id !== 'novo'">
            {{ this.entity.por }} edição:
          </h3>
        </b-col>
      </b-row>
      <b-row>
        <div v-show="loading" class="loading-holder">
          <div class="loading-spinner"></div>
        </div>
      </b-row>
      <b-row v-show="!loading">
        <b-col md="9" xs="12" class="mt-3">
          <!-- Field item -->
          <div role="group">
            <label for="nome">Título *</label>
            <b-form-input
              id="title"
              v-model="post.title"
              aria-describedby="input-live-help input-live-feedback"
              placeholder
              trim
            ></b-form-input>
          </div>
          <!-- Field item end -->
        </b-col>
        <b-col md="3" xs="12" class="mt-3">
          <!-- Field item -->
          <div role="group">
            <label for="nome">Data de Publicação *</label>
            <b-form-input
              id="title"
              v-model="post.timestamp"
              aria-describedby="input-live-help input-live-feedback"
              placeholder
              required="required"
              type="date"
            ></b-form-input>
          </div>
          <!-- Field item end -->
        </b-col>

        <b-col md="9" xs="12" class="mt-3">
          <!-- Field item -->
          <div role="group">
            <label for="nome">Categorias * (separadas por vírgula):</label>
            <b-form-input
              id="category"
              v-model="post.category"
              aria-describedby="input-live-help input-live-feedback"
              placeholder
              trim
            ></b-form-input>
          </div>
          <!-- Field item end -->
        </b-col>

        <b-col md="3" xs="12" class="mt-3">
          <!-- Field item -->
          <div role="group">
            <label for="nome">Tempo de leitura *</label>
            <b-form-input
              id="readTime"
              v-model="post.readTime"
              aria-describedby="input-live-help input-live-feedback"
              placeholder="Ex: 15 mins"
              trim
            ></b-form-input>
          </div>
          <!-- Field item end -->
        </b-col>

        <b-col md="12" xs="12" class="mt-3">
          <div role="group">
            <label for="description">Descrição:</label>
            <vue-editor
              id="description"
              v-model="post.description"
            ></vue-editor>
          </div>
        </b-col>
        <b-col md="12" xs="12" class="mt-3">
          <div role="group">
            <label for="description">Imagem:</label>
            <div v-show="post.image">
              <b-img :src="post.image" fluid></b-img>
              <b-button type="submit" variant="danger" @click="removerImagem"
                >Remover Imagem</b-button
              >
            </div>
            <div v-show="!post.image" class="my-btn">
              <input @change="processFile()" type="file" ref="myFiles" />
              <span>Adicionar Imagem</span>
            </div>
          </div>
        </b-col>

        <b-col cols="12" class="mt-4 mb-4">
          <div class="mt-4" v-show="!saving">
            <b-button type="submit" variant="primary" @click="save">
              <span>Salvar</span>
            </b-button>
          </div>
          <div v-show="saving" class="loading-spinner mt-4"></div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import http from "@/http";
import router from "@/router";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import authentication from "../util/authentication";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import { VueEditor } from "vue2-editor";

export default {
  name: "PostCrud",
  data() {
    return {
      entity: {
        eng: "post",
        por: "Post"
      },
      post: {
        title: "",
        description: "",
        image: "",
        views: 0,
        claps: 0,
        category: "",
        readTime: "",
        timestamp: new Date().toISOString().substr(0, 10)
      },
      loading: true,
      saving: false,
      file: {}
    };
  },
  components: {
    Sidebar,
    Header,
    Footer,
    VueEditor,
    VueUploadMultipleImage
  },
  methods: {
    processFile() {
      var vm = this; // vue model;
      var reader = new FileReader();
      if (this.$refs.myFiles.files && this.$refs.myFiles.files[0]) {
        var fileName = this.$refs.myFiles.files[0].name;
        reader.readAsDataURL(this.$refs.myFiles.files[0]);
        reader.onload = function(event) {
          if (event.target.readyState == FileReader.DONE) {            
            vm.post.image = event.target.result;
            vm.post.imageName = fileName;
          }
        };
      } else {
        alert("Algo deu errado com o upload da imagem.");
      }
    },
    save() {
      if (
        !this.post.title ||
        !this.post.description ||
        !this.post.category ||
        !this.post.image ||
        !this.post.timestamp ||
        !this.post.readTime
      ) {
        alert("Por favor, preencha todos os campos obrigatórios");
        return;
      }

      this.saving = true;

      if (this.$route.params.id === "novo") {
        http
          .post(this.entity.eng, this.post, authentication.getHeaders())
          .then(response => {
            alert("Cadastro realizado com sucesso.");
            router.push(`/${this.entity.por}`);
          })
          .catch(err => {
            console.error(err);
          })
          .finally(() => {
            this.saving = false;
          });
      } else {
        http
          .put(this.entity.eng, this.post, authentication.getHeaders())
          .then(response => {
            alert("Alterações salvas com sucesso.");
            router.push(`/${this.entity.por}`);
          })
          .catch(err => {
            console.error(err);
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    removerImagem() {
      this.post.image = null;
    }
  },
  created() {
    if (this.$route.params.id !== "novo") {
      http
        .get(
          `${this.entity.eng}?value=${this.$route.params.id}`,
          authentication.getHeaders()
        )
        .then(response => {
          if (response.data) {
            this.post = response.data;
            this.post.attachment.map(attach => {
              attach.path = attach.file;
              this.anexos.push(attach);
            });
            this.post.timestamp = new Date(this.post.timestamp)
              .toISOString()
              .substr(0, 10);
          } else {
            router.push(`/${this.entity.por}`);
          }
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      this.loading = false;
    }
  }
};
</script>

<style scoped>
input[type="date"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  display: none;
}

img {
  max-height: 160px;
  margin-right: 25px;
}

.rs-group-checkbox > div {
  position: relative;
  width: 120px !important;
  height: 30px;
}

legend,
label:not(.custom-control-label) {
  font-weight: bold;
  font-size: 1em;
}

.my-btn {
  position: relative;
  display: inline-block;
  max-width: 300px;
  padding: 10px 18px;
  border-radius: 4px;
  background-color: #26a69a;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.3);
}

.my-btn input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}

.my-btn span {
  font-size: 16px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/PostCrud.vue